export const JOBS_SKIPPED_EVENT = "RealQueue/JobsSkipped";
